import {
  createPunterContext,
  createPunterPreferences,
  type PunterContext,
} from '@/app/runtime/punter';
import { createTenantContext, type TenantContext } from '@/app/runtime/tenant';
import { createChildIntegratorInstance } from '@/app/runtime/tenant/infrastructure/createChildIntegrator';

export type ConnectedRuntime = {
  tenantContext: TenantContext;
  punterContext: PunterContext;
};

/**
 * Creates tenant + punter contexts and waits for integrator `onLoad`
 * (or standalone hydration) before resolving.
 */
export async function connectRuntime(): Promise<ConnectedRuntime> {
  const queryParams = new URLSearchParams(window.location.search);
  const { NXG_SPORTS_ENVIRONMENT, NXG_SPORTS_PROVIDER_ID } = import.meta.env;

  const tenantContext = createTenantContext({
    createChildIntegrator: createChildIntegratorInstance,
  });

  const punterContext = createPunterContext({
    preferences: createPunterPreferences(),
  });

  tenantContext.commands.connectIntegrator(punterContext, {
    environment: NXG_SPORTS_ENVIRONMENT ?? 'production',
    providerId: Number(NXG_SPORTS_PROVIDER_ID),
    version: '1.0.0',
    displayId: queryParams.get('displayId') ?? 'sportsbook',
    debug: queryParams.get('debug') === 'true',
  });

  return { tenantContext, punterContext };
}
